import { GenericLink, useMasterData } from '@nextgen-web-framework/all';
import { Fragment, FC } from 'react';
import { Config } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';
import HeaderLanguage from '../HeaderLanguage/HeaderLanguage';
import type { SiteNavigationProps } from './types/propsTypes';
import styles from './SiteNavigation.module.scss';

const SiteNavigation: FC<SiteNavigationProps> = ({ linkData: { leftSection }, locale, langHandler }) => {
  const webShopConfigs = useMasterData<Config>('WebshopConfigs') as Config;
  return (
    <header className={styles['site-navigation-wrapper']} data-testid="sitenavigation-test-id">
      {leftSection && leftSection.length > 0 && (
        <>
          <div className={styles['site-navigation-left-nav']} data-testid="sitenavigation-left-test-id">
            {leftSection.map((data) => (
              <Fragment key={data?.title}>
                <GenericLink href={data.href} target={data?.target} forceNative={false} key={data.title}>
                  <div className={styles['generic-link-title']}>{data.title}</div>
                </GenericLink>
              </Fragment>
            ))}
          </div>
          {webShopConfigs?.locales?.length > 1 && <HeaderLanguage langHandler={langHandler} locale={locale} />}
        </>
      )}
    </header>
  );
};

export default SiteNavigation;
